import * as Sentry from '@sentry/react'
import Mixpanel from 'mixpanel-browser'

type EventProperties = {
  [key: string]: string | number | boolean | null | number[] | object
}

type Domain =
  | 'PAGEVIEW'
  | 'ONBOARDING'
  | 'AUTH'
  | 'ACCOUNT'
  | 'RESET-PASSWORD'
  | 'UPDATE'

export const sendAnalyticsEvent = (
  domain: Domain,
  event: string,
  properties?: EventProperties
) => {
  const eventName = `${domain}|${event}`
  if (import.meta.env.VITE_MIXPANEL_ACTIVATED == 'true') {
    Mixpanel.track(eventName, properties)
  } else if (import.meta.env.VITE_MIXPANEL_DEBUGGING == 'true') {
    // eslint-disable-next-line no-console
    console.log('Tracking event: ', eventName, properties)
  }
}

export const trackOnboardingStart = () => {
  if (import.meta.env.VITE_MIXPANEL_ACTIVATED === 'true') {
    Mixpanel.track('onboarding:start')
  }
}

export const identifyUser = (id: string) => {
  if (import.meta.env.VITE_MIXPANEL_ACTIVATED == 'true') {
    Mixpanel.alias(id)
    Mixpanel.identify(id)
  }
  if (import.meta.env.VITE_SENTRY_ACTIVE === 'true') {
    Sentry.setUser({ id })
  }
}

export const clearMixpanelUser = () => {
  if (import.meta.env.VITE_MIXPANEL_ACTIVATED == 'true') {
    Mixpanel.reset()
  }
}

type UserProperties = {
  $email?: string
  $phone?: string
  $name?: string
}

export const setUserProperties = (properties: UserProperties) => {
  if (import.meta.env.VITE_MIXPANEL_ACTIVATED == 'true') {
    Mixpanel.people.set(properties)
  }
}
